import { type ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuthenticated } from "@/zapi-frontend/shared/hooks/useAuthenticated";

type TProps = {
  children: ReactElement;
};

export function NonProtectedRoute({ children }: TProps) {
  const { data: isAuth, isLoading } = useAuthenticated();

  if (isLoading) return null;
  if (isAuth) return <Navigate to="/" replace />;

  return <div>{children}</div>;
}
